module.exports = __webpack_public_path__ + "img/yuzhong.29a8faaf.jpg";